import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { connect, useDispatch } from "react-redux";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import Modal from "@mui/material/Modal";
import compose from "recompose/compose";
import PropTypes from "prop-types";
import MuiAlert from "@mui/material/Alert";
import PasswordModal from "../common/PasswordModal";
import PhoneModal from "../common/PhoneModal";
import EmailModal from "../common/EmailModal";
import { withRouter } from "react-router-dom";
import store from "../../store";
import { logout, changeAvatar } from "../../actions/auth";
import userIcon from "../../assets/images/icon-user.png";
import { getUserInfo, uploadFile, editUserInfo } from "../../actions/subscribe";
import { Input, Form, Button, message } from 'antd'
import { CHANGE_AVATAR } from '../../actions/types'
const styles = () => {
  return {
    root: {
      width: "100%",
      padding: "10px",
    },
    topBar: {
      width: "100%",
      padding: "10px 20px",
      marginBottom: "10px",
      background: "#FFFFFF",
      boxShadow: "0px 1px 5px 1px rgba(0, 0, 0, 0.1)",
      borderRadius: "5px",
      fontSize: '16px',
      color: '#333'
    },
    container: {
      width: "100%",
      padding: "10px 0",
      background: "#FFFFFF",
      boxShadow: "0px 1px 5px 1px rgba(0, 0, 0, 0.1)",
      borderRadius: "5px",
    },
    title: {
      paddingLeft: "20px",
      paddingBottom: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
      borderBottom: "1px solid #ddd",
    },
    main: {
      width: "100%",
      padding: "20px 10px",
      display: "flex",
    },
    formBox: {
      flex: "3",
      height: "100%",
      padding: "0 20px",
    },
    header: {
      flex: "2",
      height: "400px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    headerBox: {
      width: "200px",
      height: "200px",
      cursor: "pointer",
      borderRadius: '50%',
      overflow: 'hidden',
      marginBottom: "12px"
    },
    text: {
      cursor: "pointer",
      fontSize: "14px",
      color: '#333'
    },
    form: {
      paddingTop: "10px",
      paddingRight: "30px",
      display: "flex",
      flexFlow: "column",
      justifyContent: "center",
      "&.border": {
        borderLeft: "1px solid #ddd",
        paddingLeft: "30px",
      },
    },
    formItem: {
      width: '80%',
      maxWidth: "500px",
      display: "flex",
      alignItem: "center",
      marginBottom: "20px",
      "&:last-child": {
        marginBottom: "10px",
      },
    },
    label: {
      width: "100px",
      lineHeight: "32px",
      fontSize: "14px",
      color: "#000",
      textAlign: "right",
    },
    info: {
      flex: "1",
      fontSize: "14px",
      color: "#333",
    },
    btn: {
      fontSize: "14px",
      color: "#1bbe25",
      cursor: "pointer",
      textDecoration: "underline",
    },
  };
};

class UserCenter extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    // 创建表单实例
    this.formRef = React.createRef();
    // input file
    this.fileRef = React.createRef();
  }

  state = {
    openPasswordModal: false,
    openEmailModal: false,
    openPhoneModal: false,
    loginTime: "",
    openMessage: false,
    successMessage: "修改成功",
    showEdit: false,
    fileUrl: "",
    form: {
      username: store.getState().auth.username,
      phone: "",
      email: "",
      position: "",
      company: "",
      isManager: "",
      department: "",
    }
  };

  componentDidMount() {
    this.refreshUserInfo();

    let time = localStorage.getItem('loginTime')
    if (!time) {
      time = new Date().toISOString().substring(0, 10)
    }
    this.setState({
      loginTime: time
    })
  }



  refreshUserInfo() {
    getUserInfo({ username: store.getState().auth.username }).then((res) => {
      if (res.results && res.results.length > 0) {
        let userData = res.results.filter((v) => {
          return v.username == store.getState().auth.username;
        })[0];
        if (userData) {
          
          // 修改全局头像
          this.props.changeAvatar(userData.avatar)
          let param = {
            username: store.getState().auth.username,
            phone: userData.mobile,
            email: userData.email,
            company: userData.company_name,
            isManager: userData.is_manager,
            position: userData.position,
            department: userData.department,
          }
          this.formRef.current && this.formRef.current.setFieldsValue({
            ...param
          })
          this.setState({
            form: {
              ...param
            },
            fileUrl: userData.avatar
          })
        }
      }
    });
  }

  //关闭消息弹框
  closeMessage = () => {
    this.setState({
      openMessage: false,
    });
  };

  // 打开修改密码弹框
  editPassword = () => {
    this.setState({
      openPasswordModal: true,
    });
  };

  //修改密码
  submitEditPassword = () => {
    this.setState({
      openPasswordModal: false,
      openMessage: true,
    });
    setTimeout(() => {
      this.closeMessage();
    }, 2000);
  };

  // 打开修改邮箱弹框
  editEmail = () => {
    this.setState({
      openEmailModal: true,
    });
  };


  // 打开修改手机弹框
  editPhone = () => {
    this.setState({
      openPhoneModal: true,
    });
  };

  //修改手机
  submitEditPhone = () => {
    this.refreshUserInfo();
    this.setState({
      openPhoneModal: false,
      openMessage: true,
    });
    setTimeout(() => {
      this.closeMessage();
    }, 2000);
  };

  //关闭弹框
  handleClose = () => {
    this.setState({
      openPasswordModal: false,
      openEmailModal: false,
      openPhoneModal: false,
    });
  };

  onFinish = (values) => {
    editUserInfo({
      mobile: values.phone,
      email: values.email,
      department: values.department,
      position: values.position,
      avatar: this.state.fileUrl,
    }).then(res => {
      if (res.user_id) {
        this.setState({
          form: {
            ...res
          },
          showEdit: false
        })
        message.success('修改成功')
      }
    })
  };
  onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  submit = () => {
    this.setState({
      showEdit: true
    })
  }

  cancelEdit = () => {
    let param = {
      ...this.state.form
    }
    this.formRef.current && this.formRef.current.setFieldsValue({
      ...param
    })
    this.setState({
      showEdit: false
    })
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  chooseFile = () => {
    this.fileRef && this.fileRef.current.click()
  }

  changeFile = (e) => {
    let file = e.target.files[0]
    let fileName = file.name
    let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
    let fileList = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg']
    if (fileList.indexOf(fileType) === -1) {
      message.warning('文件格式不正确')
      return
    }
    let form = new FormData()
    form.append('file1', file)
    form.append('file_category', 'avatar')
    uploadFile(form).then(res => {
      let data = res.message[0]
      if (data) {
        this.setState({
          fileUrl: data.dfs_url
        })
        // 保存信息
        editUserInfo({
          mobile: this.state.form.phone,
          email: this.state.form.email,
          department: this.state.form.department,
          position: this.state.form.position,
          avatar: data.dfs_url,
        }).then(res => {
          if (res.user_id) {
            message.success('修改成功')
            this.props.changeAvatar(data.dfs_url)
          }
        })
      }
    })
  }

  render() {
    const classes = this.props.classes;
    const { avatar } = this.props

    const toLogout = () => {
      this.props.logout()
    }
  
    return (
      <Grid className={classes.root}>
        <Grid className={classes.topBar}>
          登录日期：{this.state.loginTime}
        </Grid>

        <Grid className={classes.container}>
          <Grid className={classes.title}> 个人信息</Grid>
          <Grid className={classes.main}>
            <Grid className={classes.header}>
              <Grid className={classes.headerBox} onClick={this.chooseFile}>
                {
                  avatar ?
                  <img src={avatar} style={{width: "200px", height: "200px"}}/> :
                  <img src={userIcon} style={{width: "200px", height: "200px"}}/>
                }
              </Grid>
              <span className={classes.text} onClick={this.chooseFile}>
                点击上传头像
              </span>
              <input type="file" id="avatarFile" accept="image/*" ref={this.fileRef} onChange={this.changeFile} style={{display: "none"}}/>
            </Grid>
            <Grid className={classes.formBox}>
              <Grid className={classes.form}>
                <Form
                  labelCol={{
                    span: 4,
                  }}
                  wrapperCol={{
                    span: 16,
                  }}
                  initialValues={{
                  }}
                  ref={this.formRef}
                  onFinish={this.onFinish}
                  onFinishFailed={this.onFinishFailed}
                  autoComplete="off"
                >
                  <Form.Item
                    name="company"
                    label="公司名称"
                  >
                    <Input readOnly={true}  />
                  </Form.Item>
                  <Form.Item
                    label="用户名"
                    name="username"
                  >
                    <Input readOnly={true} />
                  </Form.Item>
                  
                  <Form.Item
                    label="手机号码"
                    name="phone"
                    rules={[
                      {
                        required: this.state.showEdit,
                        message: '请输入手机号码!',
                      },
                    ]}  
                  >
                    <Input  readOnly={!this.state.showEdit} allowClear />
                  </Form.Item>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      {
                        required: this.state.showEdit,
                        message: '请输入Email!',
                      },
                    ]}  
                  >
                    <Input  readOnly={!this.state.showEdit} allowClear />
                  </Form.Item>
                  <Form.Item
                    label="部门名称"
                    name="department"
                    rules={[
                      {
                        message: '请输入部门名称!',
                      },
                    ]}  
                  >
                    <Input  readOnly={!this.state.showEdit} allowClear />
                  </Form.Item>
                  <Form.Item
                    label="所属职位"
                    name="position"
                    rules={[
                      {
                        message: '请输入所属职位!',
                      },
                    ]}  
                  >
                    <Input  readOnly={!this.state.showEdit} allowClear />  
                  </Form.Item>
                  <Form.Item
                    label=""
                    wrapperCol={{
                      offset: 4
                    }}
                  >
                    <div >
                      {
                        !this.state.showEdit &&
                        <Button type="primary" onClick={this.submit}>编辑信息</Button>
                      }
                      {
                        this.state.showEdit &&
                        <>
                        <Button type="primary" htmlType="submit">保存编辑</Button>
                        <Button type="info" style={{marginLeft: "14px"}} onClick={this.cancelEdit}>不保存退出</Button>
                        </>

                      }
                      {
                        !this.state.showEdit &&
                        <Button type="info" style={{marginLeft: "14px"}} onClick={toLogout}>退出登录</Button>
                      }
                    </div>
                  </Form.Item>

                </Form>
              </Grid>
            </Grid>
          </Grid>
        </Grid>        
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  avatar: state.auth.avatar,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, { logout, changeAvatar })
)(withRouter(UserCenter));
